import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'social.facebook.label',
    defaultMessage: 'Connect Facebook Profile'
  }
});
